import React, { useEffect, useState } from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import {
  Row, Col, Input, Form, Upload, Button, message, notification,
} from 'antd';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import { UploadOutlined } from '@ant-design/icons';
import { func, shape } from 'prop-types';
import { STUDENT_ACTIVITIES } from '../../../../routes';

import { CREATE_ACTIVITY_SUBMISSION, GET_STUDENT_ACTIVITIES } from '../../../../graphql';
import { uploadFiles } from '../../../../upload';

const { Item: FormItem } = Form;
const SubmitForm = ({
  form, setLoading, activity,
}) => {
  const client = useApolloClient();
  const [uploadLoading, setUploadLoading] = useState(false);
  const [submitActivity, { loading: submissionLoading }] = useMutation(CREATE_ACTIVITY_SUBMISSION);
  const navigate = useNavigate();
  useEffect(() => {
    if (uploadLoading || submissionLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [uploadLoading, setLoading, submissionLoading]);

  const handleFormSubmit = async (inputs) => {
    const { textContent, attachments } = inputs;
    const files = (attachments?.fileList ?? []).map((file) => file.originFileObj || file);

    if (!textContent && files.length === 0 && !activity.embedLink) {
      return message.error('Please provide an input');
    }

    try {
      // The author and the activity come from the token and the path; the
      // server refuses an activity this learner was not assigned.
      await submitActivity({
        variables: {
          activityId: activity.id,
          input: {
            textContent: textContent || (activity.embedLink ? 'GOOGLE FORM SUBMISSION' : undefined),
          },
        },
        update: (cache) => {
          const cached = cache.readQuery({ query: GET_STUDENT_ACTIVITIES });
          if (!cached) return;
          cache.writeQuery({
            query: GET_STUDENT_ACTIVITIES,
            data: {
              myActivities: cached.myActivities.map((item) => (
                item.activityId === activity.id ? { ...item, status: 'SUBMITTED' } : item
              )),
            },
          });
        },
      });

      // Attachments hang off the submission, so they follow it.
      if (files.length > 0) {
        setUploadLoading(true);
        try {
          await uploadFiles({
            client, files, target: 'SUBMISSION', targetId: activity.id,
          });
        } finally {
          setUploadLoading(false);
        }
      }

      notification.success({
        message: 'Activity submitted successfully',
        description: 'Your activity has been submitted',
      });
      return navigate(STUDENT_ACTIVITIES);
    } catch (error) {
      return message.error(error.message || 'Could not submit activity');
    }
  };

  return (
    <Row className="submission">
      <Col span={24}>
        <h4 className="ic-ft-dosis top">Submission</h4>
      </Col>
      <Col span={24}>
        <Form onFinish={handleFormSubmit} form={form} layout="vertical">
          {activity.embedLink && (
          <div className="embed-raper gx-mt-3">
            <h4>Note: click &quot;Complete Activity&quot; after submitting this form</h4>
            {parse(activity.embedLink)}
          </div>
          )}
          {activity.hasTextInput && (
            <FormItem name="textContent" label="Comment">
              <Input.TextArea rows={7} placeholder="write a comment for your teacher" />
            </FormItem>
          )}
          <FormItem valuePropName="file" name="attachments" label="Attach Files">
            <Upload
              listType="picture"
              beforeUpload={() => false}
            >
              <Button icon={<UploadOutlined />}>Click Here</Button>
            </Upload>
          </FormItem>
        </Form>
      </Col>

    </Row>
  );
};

SubmitForm.propTypes = {
  form: shape({}).isRequired,
  setLoading: func.isRequired,
  activity: shape({}).isRequired,
};

export default SubmitForm;
